import { type SVGProps, forwardRef } from 'react'

export const ChevronLeft = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="m12 15-5-5 5-5"
      />
    </svg>
  )
)

ChevronLeft.displayName = 'ChevronLeft'
